<template>
    <div class="card">
        <slot name="top"></slot>
        <div class="card-body">
            <h5 class="card-title" v-if="title">{{ title }}</h5>
            <div class="card-body-content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: String
    }
}
</script>